module.exports = __webpack_public_path__ + "static/media/error.1be269c5.gif";